<template>
  <div v-if="['themeKY28'].includes(THEME)" class="ios-add-home">
    <img class="logo" src="/images/add_home_logo.png" alt="">
    <div class="center">
      <div class="title">{{ mb_t('先点击') }}<img class="share" src="/images/add-home-share.png" /></div>
      <div class="sub-title">{{ mb_t('再添加到主屏幕') }}</div>
    </div>
    <div class="close" @click="$emit('close')">
      <img src="/images/add_home_close.png" alt="">
    </div>
  </div>
  <div v-if="['themeKYMN'].includes(THEME)" class="ios-add-home">
    <img class="logo" src="/images/add_home_logo2.png" alt="">
    <div class="center">
      <div class="title">{{ mb_t('先点击') }}<img class="share" src="/images/add-home-share2.png" /></div>
      <div class="sub-title">{{ mb_t('再添加到主屏幕') }}</div>
    </div>
    <div class="close" @click="$emit('close')">
      <img src="/images/add_home_close.png" alt="">
    </div>
  </div>

</template>

<script setup lang="ts">
import { mb_t } from '/@/plugins/global';

</script>

<style scoped lang="scss">
.ios-add-home {
  position: fixed;
  bottom: px2rem(10);
  left: px2rem(87);
  width: px2rem(235);
  height: px2rem(87);
  background: url(publicImgUrl("add-home-bg.png")) no-repeat;
  background-size: 100% 100%;
  z-index: 99;
  display: flex;
  align-items: center;
  gap: px2rem(12);

  .logo {
    width: px2rem(49);
    height: px2rem(49);
    margin-left: px2rem(20);
  }

  .title {
    color: #000000;
    font-size: px2rem(16);
    display: flex;
    align-items: center;
  }

  .sub-title {
    color: #666;
    font-size: px2rem(16);
  }

  .share {
    width: px2rem(24);
    height: px2rem(24);
  }

  .close {
    position: absolute;
    top: px2rem(20);
    right: px2rem(20);
    width: px2rem(16);
    height: px2rem(16);

    img {
      width: 100%;
      height: 100%;
    }
  }
}

.themeKYMN {
  .logo {
    width: px2rem(40);
    height: px2rem(40);
  }
  .title {
    font-size: px2rem(12);
  }
  .sub-title {
    font-size: px2rem(12);
  }
  .share {
    width: px2rem(16);
    height: px2rem(16);
  }
}
</style>